<!--
  Runder Outline-Button zum Hinzufügen (blau) oder Entfernen (rot) von Einträgen
-->
<template>
  <span
    class="add-remove-button"
    :class="remove ? 'add-remove-button--remove' : 'add-remove-button--add'"
    role="button"
    v-on="$listeners"
  >
    <Minus v-if="remove" :size="14" />
    <Plus v-else :size="14" />
  </span>
</template>

<script>
import { Minus, Plus } from 'lucide-vue';

export default {
  name: 'AddRemoveButton',
  components: { Minus, Plus },
  props: {
    remove: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.add-remove-button {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  border: 1px solid currentColor;
  border-radius: 50%;
  background: none;
  cursor: pointer;
  user-select: none;
}
.add-remove-button:hover {
  background-color: var(--surface-hover);
}
.add-remove-button--add {
  color: var(--primary);
}
.add-remove-button--remove {
  color: var(--danger);
}
</style>
